import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import { useIntl, FormattedMessage } from "react-intl";
import { Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import { useUiFeedback } from "../../../../context/ui-feedback/ui-feedback";
import { createErrorFeedback } from "../../../../context/ui-feedback/action";
import { useSearchWorkers } from "../../../../api/users-api";
import { Loading } from "../../../common/loading/loading";

export const UserSelect = ({ userId, handleUserSelect }) => {
  const intl = useIntl();
  const navigate = useNavigate();
  const searchWorkers = useSearchWorkers();

  const { uiFeedbackDispatch } = useUiFeedback();

  const loadedUsers = useRef(null);
  const [users, setUsers] = useState(null);

  useEffect(() => {
    const loadWorkers = async () => {
      try {
        await searchWorkers((data) => {
          if (data instanceof Error) {
            throw data;
          } else {
            let usereData = data.map((u) => {
              return {
                id: u.id,
                name: u.name,
                user: u,
              };
            });
            usereData.sort((u1, u2) => u1.name.localeCompare(u2.name));
            setUsers(usereData);
          }
        });
      } catch (ex) {
        if (ex.response?.status === 401 || ex.response?.status === 403) {
          navigate("/");
        } else {
          createErrorFeedback(
            uiFeedbackDispatch,
            intl.formatMessage({
              id: "page.apps.exception.loadusers.title",
            }),
            intl.formatMessage({
              id: "page.apps.exception.loadusers.description",
            }),
          );
        }
      }
    };

    const checkNotEmpy = (items) => {
      return items.filter((item) => item === null).length === 0;
    };

    if (
      loadedUsers.current === null &&
      users === null &&
      checkNotEmpy([searchWorkers, intl, navigate, uiFeedbackDispatch])
    ) {
      loadWorkers();
      loadedUsers.current = new Date();
    }
  }, [loadedUsers, users, searchWorkers, intl, navigate, uiFeedbackDispatch]);

  return (
    <Form.Select
      value={userId ? userId : -1}
      onChange={(event) => {
        handleUserSelect(
          event.target.value === "-1"
            ? null
            : users.find((u) => u.id === event.target.value).user,
        );
      }}
    >
      <option value="-1">
        <FormattedMessage id="data.apps.form.workers.value.null" />
      </option>
      {!users ? (
        <Loading />
      ) : (
        <>
          {users.map((user) => (
            <option key={user.id} value={user.id}>
              {user.name}
            </option>
          ))}
        </>
      )}
    </Form.Select>
  );
};

UserSelect.propTypes = {
  userId: PropTypes.string,
  handleUserSelect: PropTypes.func.isRequired,
};
